import { useRouter, type ErrorComponentProps } from '@tanstack/react-router';

import { ErrorState } from './ErrorState';

/** Route-level error boundary. Retrying invalidates the router so loaders re-run. */
export function RouteErrorState({ error }: ErrorComponentProps) {
  const router = useRouter();

  return (
    <ErrorState
      error={error}
      subject="this screen"
      onRetry={() => {
        void router.invalidate();
      }}
    />
  );
}
